// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-printer {
  max-width: 100%;
}

.label-printer__state,
.label-printer__empty {
  align-items: center;
  display: flex;
  gap: 0.6rem;
  justify-content: center;
  min-height: 8rem;
}

.label-printer__empty {
  color: var(--text-muted, #666);
  font-style: italic;
}

.label-printer__layout {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.label-printer__controls {
  flex: 1 1 22rem;
  max-width: 32rem;
  min-width: 0;
}

.label-printer__preview {
  flex: 3 1 24rem;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
}

/* A sheet is its real paper width (8.5in is 816px), so it is never shrunk to fit the preview
   column. The column scrolls sideways instead. */
.label-printer__preview .label-sheets,
.label-printer__preview .packing-slips {
  align-items: flex-start;
  width: max-content;
}

.label-printer__actions {
  margin-top: 1.25rem;
}

.label-printer__actions button + button {
  margin-left: 0.5rem;
}

.label-printer__summary {
  font-weight: 700;
}

.label-printer__hint {
  color: var(--text-muted, #666);
  font-size: 0.9em;
}

.label-order-picker__header {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.label-order-picker__header h3 {
  flex: 1 1 100%;
  margin: 0;
}

.label-order-picker__count {
  color: var(--text-muted, #666);
  margin-right: auto;
}

.label-order-picker__list {
  border: 1px solid #ddd;
  list-style: none;
  margin: 0.5rem 0 1rem;
  max-height: 16rem;
  overflow-y: auto;
  padding: 0.25rem 0.75rem;
}

.label-order-picker__warning {
  color: #a15c00;
}

.label-options-form fieldset {
  border: 1px solid #ddd;
  margin: 0 0 1rem;
}

.label-options-form fieldset label {
  display: block;
}

.label-options-form__field {
  margin-bottom: 1rem;
}

.label-options-form__field label {
  display: block;
}

.label-options-form__field textarea,
.label-options-form__field select {
  max-width: 100%;
  width: 100%;
}

/* Sheets. Sizes come from inline inch styles; the layout is ported from print-labels.ejs.
   A sheet or slip is paper: it keeps a dark ink color on white even when the dashboard theme
   sets a light text color (data-theme="dark"), on screen and in print. */
.label-sheets,
.packing-slips {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.label-sheet,
.packing-slip {
  background: #fff;
  color: #111;
  color-scheme: light;
}

.label-sheet {
  align-content: center;
  align-items: center;
  background: #fff;
  border: 1px solid #ccc;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: space-around;
  overflow: hidden;
}

.label-sheet__label {
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 400;
  justify-content: center;
  overflow: hidden;
  padding: 0.25in;
  text-align: center;
  white-space: pre;
}

.label-sheet__label--skipped {
  background: #ccc;
  cursor: not-allowed;
}

.label-sheet__label--empty {
  border-style: dashed;
}

.packing-slip {
  background: #fff;
  border: 1px solid #ccc;
  box-sizing: border-box;
  flex-shrink: 0;
  font-size: 14px;
  overflow: hidden;
  padding: 0.6in;
  text-align: left;
}

/* (0,2,1) so it beats the dashboard's \`div.page section h2\` (0,1,3): R1. */
.packing-slip h2.packing-slip__store {
  border: none;
  color: inherit;
  margin: 0;
  padding: 0;
}

.packing-slip h3 {
  color: inherit;
}

.packing-slip__title {
  letter-spacing: 0.1em;
  margin: 0 0 1rem;
  text-transform: uppercase;
}

.packing-slip__orders {
  list-style: none;
  margin: 0 0 1.25rem;
  padding: 0;
}

.packing-slip__ship-to p,
.packing-slip__message p {
  white-space: pre-line;
}

/* The dashboard stylesheet styles every bare table (borders, grey header, striped and hover
   rows). The slip table opts out of all of it with selectors under its own wrapper. */
.packing-slip .packing-slip__items {
  border-collapse: collapse;
  margin: 1.25rem 0;
  width: 100%;
}

.packing-slip .packing-slip__items th,
.packing-slip .packing-slip__items td {
  background: transparent;
  border: 0;
  border-bottom: 1px solid #ccc;
  color: inherit;
  font-size: 14px;
  padding: 0.4rem 0.25rem;
  text-align: left;
  vertical-align: top;
}

.packing-slip .packing-slip__items tr,
.packing-slip .packing-slip__items tr:nth-child(even),
.packing-slip .packing-slip__items tr:hover {
  background: transparent;
}

.packing-slip .packing-slip__items th:last-child,
.packing-slip .packing-slip__items td:last-child {
  text-align: right;
  width: 3rem;
}

.packing-slip__variant {
  color: #444;
}

/* The print copy lives in a body-level portal: invisible on screen, shown by printSheets(). */
.label-print-root {
  display: none;
}

@media print {
  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  .label-print-root .label-sheets,
  .label-print-root .packing-slips {
    display: block;
    gap: 0;
  }

  .label-print-root .label-sheet,
  .label-print-root .packing-slip {
    border: none;
    break-after: page;
    break-inside: avoid;
    margin: 0;
    page-break-after: always;
    page-break-inside: avoid;
  }

  .label-print-root .label-sheet:last-child,
  .label-print-root .packing-slip:last-child {
    break-after: auto;
    page-break-after: auto;
  }

  .label-print-root .label-sheet {
    display: flex;
  }

  .label-print-root .label-sheet__label {
    border: none;
  }

  .label-print-root .label-sheet__label--skipped,
  .label-print-root .label-sheet__label--empty {
    background: transparent;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Labels/LabelPrinter.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;iDACiD;AACjD;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;;yEAEyE;AACzE;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;sFACsF;AACtF;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,8FAA8F;AAC9F;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;;IAEE,cAAc;IACd,MAAM;EACR;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA;;IAEE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,uBAAuB;EACzB;AACF","sourcesContent":[".label-printer {\n  max-width: 100%;\n}\n\n.label-printer__state,\n.label-printer__empty {\n  align-items: center;\n  display: flex;\n  gap: 0.6rem;\n  justify-content: center;\n  min-height: 8rem;\n}\n\n.label-printer__empty {\n  color: var(--text-muted, #666);\n  font-style: italic;\n}\n\n.label-printer__layout {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n.label-printer__controls {\n  flex: 1 1 22rem;\n  max-width: 32rem;\n  min-width: 0;\n}\n\n.label-printer__preview {\n  flex: 3 1 24rem;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n}\n\n/* A sheet is its real paper width (8.5in is 816px), so it is never shrunk to fit the preview\n   column. The column scrolls sideways instead. */\n.label-printer__preview .label-sheets,\n.label-printer__preview .packing-slips {\n  align-items: flex-start;\n  width: max-content;\n}\n\n.label-printer__actions {\n  margin-top: 1.25rem;\n}\n\n.label-printer__actions button + button {\n  margin-left: 0.5rem;\n}\n\n.label-printer__summary {\n  font-weight: 700;\n}\n\n.label-printer__hint {\n  color: var(--text-muted, #666);\n  font-size: 0.9em;\n}\n\n.label-order-picker__header {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.label-order-picker__header h3 {\n  flex: 1 1 100%;\n  margin: 0;\n}\n\n.label-order-picker__count {\n  color: var(--text-muted, #666);\n  margin-right: auto;\n}\n\n.label-order-picker__list {\n  border: 1px solid #ddd;\n  list-style: none;\n  margin: 0.5rem 0 1rem;\n  max-height: 16rem;\n  overflow-y: auto;\n  padding: 0.25rem 0.75rem;\n}\n\n.label-order-picker__warning {\n  color: #a15c00;\n}\n\n.label-options-form fieldset {\n  border: 1px solid #ddd;\n  margin: 0 0 1rem;\n}\n\n.label-options-form fieldset label {\n  display: block;\n}\n\n.label-options-form__field {\n  margin-bottom: 1rem;\n}\n\n.label-options-form__field label {\n  display: block;\n}\n\n.label-options-form__field textarea,\n.label-options-form__field select {\n  max-width: 100%;\n  width: 100%;\n}\n\n/* Sheets. Sizes come from inline inch styles; the layout is ported from print-labels.ejs.\n   A sheet or slip is paper: it keeps a dark ink color on white even when the dashboard theme\n   sets a light text color (data-theme=\"dark\"), on screen and in print. */\n.label-sheets,\n.packing-slips {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.label-sheet,\n.packing-slip {\n  background: #fff;\n  color: #111;\n  color-scheme: light;\n}\n\n.label-sheet {\n  align-content: center;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  overflow: hidden;\n}\n\n.label-sheet__label {\n  align-items: center;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  font-weight: 400;\n  justify-content: center;\n  overflow: hidden;\n  padding: 0.25in;\n  text-align: center;\n  white-space: pre;\n}\n\n.label-sheet__label--skipped {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.label-sheet__label--empty {\n  border-style: dashed;\n}\n\n.packing-slip {\n  background: #fff;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  font-size: 14px;\n  overflow: hidden;\n  padding: 0.6in;\n  text-align: left;\n}\n\n/* (0,2,1) so it beats the dashboard's `div.page section h2` (0,1,3): R1. */\n.packing-slip h2.packing-slip__store {\n  border: none;\n  color: inherit;\n  margin: 0;\n  padding: 0;\n}\n\n.packing-slip h3 {\n  color: inherit;\n}\n\n.packing-slip__title {\n  letter-spacing: 0.1em;\n  margin: 0 0 1rem;\n  text-transform: uppercase;\n}\n\n.packing-slip__orders {\n  list-style: none;\n  margin: 0 0 1.25rem;\n  padding: 0;\n}\n\n.packing-slip__ship-to p,\n.packing-slip__message p {\n  white-space: pre-line;\n}\n\n/* The dashboard stylesheet styles every bare table (borders, grey header, striped and hover\n   rows). The slip table opts out of all of it with selectors under its own wrapper. */\n.packing-slip .packing-slip__items {\n  border-collapse: collapse;\n  margin: 1.25rem 0;\n  width: 100%;\n}\n\n.packing-slip .packing-slip__items th,\n.packing-slip .packing-slip__items td {\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid #ccc;\n  color: inherit;\n  font-size: 14px;\n  padding: 0.4rem 0.25rem;\n  text-align: left;\n  vertical-align: top;\n}\n\n.packing-slip .packing-slip__items tr,\n.packing-slip .packing-slip__items tr:nth-child(even),\n.packing-slip .packing-slip__items tr:hover {\n  background: transparent;\n}\n\n.packing-slip .packing-slip__items th:last-child,\n.packing-slip .packing-slip__items td:last-child {\n  text-align: right;\n  width: 3rem;\n}\n\n.packing-slip__variant {\n  color: #444;\n}\n\n/* The print copy lives in a body-level portal: invisible on screen, shown by printSheets(). */\n.label-print-root {\n  display: none;\n}\n\n@media print {\n  html,\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .label-print-root .label-sheets,\n  .label-print-root .packing-slips {\n    display: block;\n    gap: 0;\n  }\n\n  .label-print-root .label-sheet,\n  .label-print-root .packing-slip {\n    border: none;\n    break-after: page;\n    break-inside: avoid;\n    margin: 0;\n    page-break-after: always;\n    page-break-inside: avoid;\n  }\n\n  .label-print-root .label-sheet:last-child,\n  .label-print-root .packing-slip:last-child {\n    break-after: auto;\n    page-break-after: auto;\n  }\n\n  .label-print-root .label-sheet {\n    display: flex;\n  }\n\n  .label-print-root .label-sheet__label {\n    border: none;\n  }\n\n  .label-print-root .label-sheet__label--skipped,\n  .label-print-root .label-sheet__label--empty {\n    background: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
